import styled from 'styled-components';

export const Container = styled.div`
background-color: #fff;
border-radius: 10px;
box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
position: relative;
overflow: hidden;
width: 678px;
max-width: 100%;
min-height: 400px;
`;

export const SignUpContainer = styled.div`
 position: absolute;
 top: 0;
 height: 100%;
 transition: all 0.6s ease-in-out;
 left: 0;
 width: 50%;
 opacity: 0;
 z-index: 1;
 ${props => props.signinIn !== true ? `
   transform: translateX(100%);
   opacity: 1;
   z-index: 3;
 `
    : null}
`;


export const SignInContainer = styled.div`
position: absolute;
top: 0;
height: 100%;
transition: all 0.6s ease-in-out;
left: 0;
width: 50%;
z-index: 2;
${props => (props.signinIn !== true ? `transform: translateX(100%);` : null)}
`;

export const Form = styled.form`
background-color: #ffffff;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
padding: 0 50px;
height: 100%;
text-align: center;
`;

export const Title = styled.h1`
font-weight: bold;
margin: 0;
`;

export const Input = styled.input`
background-color: #eee;
border: none;
padding: 12px 15px;
margin: 8px 0;
width: 100%;
`;


export const Button = styled.button`
   border-radius: 20px;
   border: 1px solid #125b62;
   background-color: #FFC107;
   color: #ffffff;
   font-size: 12px;
   font-weight: bold;
   padding: 12px 45px;
   letter-spacing: 1px;
   text-transform: uppercase;
   transition: transform 80ms ease-in;
   &:active{
       transform: scale(0.95);
   }
   &:focus {
       outline: none;
   }
`;
export const GhostButton = styled(Button)`
background-color: transparent;
border-color: #ffffff;
`;

export const Anchor = styled.a`
color: #333;
font-size: 14px;
text-decoration: none;
margin: 15px 0;
`;
export const OverlayContainer = styled.div`
position: absolute;
top: 0;
left: 50%;
width: 50%;
height: 100%;
overflow: hidden;
transition: transform 0.6s ease-in-out;
z-index: 6;
${props =>
    props.signinIn !== true ? `transform: translateX(-100%);` : null}
`;

export const Overlay = styled.div`
background: rgb(30,41,81);
background: -webkit-linear-gradient(90deg, #212730 0%,#212730 50%, #212730 100%);
background:linear-gradient(90deg, #212730 0%,#212730 50%, #212730 100%);
background-repeat: no-repeat;
background-size: cover;
background-position: 0 0;
color: #ffffff;
position: relative;
left: -100%;
height: 100%;
width: 200%;
transform: translateX(0);
transition: transform 0.6s ease-in-out;
${props => (props.signinIn !== true ? `transform: translateX(50%);` : null)}
`;

export const OverlayPanel = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 40px;
    text-align: center;
    top: 0;
    height: 100%;
    width: 50%;
    transform: translateX(0);
    transition: transform 0.6s ease-in-out;
`;

export const LeftOverlayPanel = styled(OverlayPanel)`
  transform: translateX(-20%);
  ${props => props.signinIn !== true ? `transform: translateX(0);` : null}
`;

export const RightOverlayPanel = styled(OverlayPanel)`
    right: 0;
    transform: translateX(0);
    ${props => props.signinIn !== true ? `transform: translateX(20%);` : null}
`;

export const Paragraph = styled.p`
font-size: 14px;
  font-weight: 100;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 20px 0 30px
`;


export const BoxContainerB = styled.div`
 // width: 90%;
 display: flex;
 flex-direction: column;
 align-items: center;
 position: relative;
 // margin-top: 10px;
`;

export const FormContainerB = styled.form`
 width: 100%;
 display: flex;
 flex-direction: column;
 box-shadow: 0px 0px 2.5px rgba(15, 15, 15, 0.19);
`;

export const MutedLinkB = styled.a`
 font-size: 14px;
 color: rgba(57, 57, 57, 0.8);
 font-weight: 500;
 text-decoration: none;
`;

export const BoldLinkB = styled.a`
 font-size: 14px;
 color: #FFC107;
 font-weight: 500;
 text-decoration: none;
 margin: 0 4px;
`;

export const InputB = styled.input`
 width: 100%;
 height: 42px;
 outline: none;
 border: 1px solid rgba(200, 200, 200, 0.3);
 padding: 0px 10px;
 border-bottom: 1.4px solid transparent;
 transition: all 200ms ease-in-out;
 font-size: 12px;

 &::placeholder {
   color: rgba(200, 200, 200, 1);
 }

 &:not(:last-of-type) {
   border-bottom: 1.4px solid transparent;
 }

 &:focus {
   outline: none;
   border-bottom: 2px solid teal;
 }
`;

export const SubmitButtonB = styled.button`
 width: 100%;
 padding: 11px 40%;
 color: #fff;
 font-size: 15px;
 font-weight: 600;
 border: none;
 border-radius: 100px 100px 100px 100px;
 cursor: pointer;
 transition: all, 240ms ease-in-out;
 background: #FFC107;

 &:hover {
   filter: brightness(1.03);
 }
`;
